import { ReactElement } from 'react';
import { ReactComponent as Sectiondivider } from 'assets/svg-icons/section-divider.svg';
interface Props {
  className?: string;
}
export default function SectionDivider({ className }: Props): ReactElement {
  return <Sectiondivider className={` ${className}`} />;
}
